export default __webpack_public_path__ + "static/case-study-2-bedd7262c0ecc29a3d437314f594cbbb.webp";